var map = {
	"./multiplier-x1.png": 78,
	"./multiplier-x10.png": 79,
	"./multiplier-x10@2x.png": 80,
	"./multiplier-x1@2x.png": 81,
	"./multiplier-x2.png": 82,
	"./multiplier-x2@2x.png": 83,
	"./multiplier-x5.png": 84,
	"./multiplier-x5@2x.png": 85
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 195;



//////////////////
// WEBPACK FOOTER
// ./themes/mf/img ^\.\/multiplier\-x.*\.png$
// module id = 195
// module chunks = 3